import { render, staticRenderFns } from "./CheckingWordsForm.vue?vue&type=template&id=33277712&"
import script from "./CheckingWordsForm.vue?vue&type=script&lang=js&"
export * from "./CheckingWordsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports